import axios from 'axios';


const googleUrlSig = (imgUrl) => {
  // Lets sign each google streetview image with a unique signiture
  const url = `${process.env.VUE_APP_OA_URL}/openestimates/signurl.php`;

  const formData = new FormData();
  formData.append('input_url', imgUrl);

  return axios.post(url, formData).then(res => res.data);
};

const getGoogleStreetView = (property) => {
  // Full address encoded for google image
  const fullAddress = encodeURIComponent(`${property.streetnumber}, ${property.street},${property.suburb},${property.state},${property.postcode},australia`);

  // Google image url with encoded address
  const googleImgUrl = `https://maps.googleapis.com/maps/api/streetview?size=500x454&location=${fullAddress}&client=gme-openagentcomau`;

  const listingImgs = [];

  return googleUrlSig(googleImgUrl).then((url) => {
    listingImgs.push({
      indexid: 1, id: property.id, key: property.key, url,
    });

    return listingImgs;
  });
};

const getPhotos = (property) => {
  if (property.hasphotos) {
    // IF Agent has uploaded an image
    if (!property.providedexternalphotos && property.photos && property.photos.length > 0) {
      const { photos } = property;

      const listingImgs = [];

      for (let i = 0; i < photos.length; i++) {
        const image = photos[i];
        listingImgs.push({
          indexid: i, id: property.id, key: property.key, url: `${process.env.VUE_APP_CDN_BUYER_PROPERTY_IMG}${image.photourl}`,
        });
      }


      return Promise.resolve(listingImgs);
    }

    // If we have the rpdataid and agent has selected to external photos use Core Lodgic image
    if (property.providedexternalphotos && property.rpdataid && property.rpdataid != -1) {
      const getbppmsUrl = `${process.env.VUE_APP_CLAPI_URL}/v1/property/details?id=${property.rpdataid}`;

      const listingImgs = [];

      return axios.get(getbppmsUrl).then((res) => {
        // If at least one core logic image is returned
        if (res.data.data.photos && res.data.data.photos.length > 0) {
          const clPhotos = res.data.data.photos;

          for (let i = 0; i < clPhotos.length; i++) {
            const image = clPhotos[i];

            listingImgs.push({
              indexid: i, id: property.id, key: property.key, url: image.medium, urlLrg: image.large,
            });
          }

          return listingImgs;

          // else use the google street view image
        }
        return getGoogleStreetView(property);
      });

      // else use the google street view image
    }
    return getGoogleStreetView(property);


    // else use the google street view image
  }
  return getGoogleStreetView(property);
};


export default { getPhotos };
